import React from 'react';
import { renderers } from './renderers';

export default function ContentRenderers({ chapterType, chapterData, isValidMarkup, onContentSave, handleChange, sectionData, onFileChange, setChapterData, onSave, loading, onUpload, handleCancelUpload, ...props }) {

    const parseTypes = str => String(str).trim().replace(/\s+/g, '-').toLowerCase();

    chapterType = parseTypes(chapterType);

    const Renderer = renderers[chapterType];

    return Renderer ? <Renderer {...{ chapterData, isValidMarkup, onContentSave, handleChange, sectionData, onFileChange, setChapterData, onSave, loading, onUpload, handleCancelUpload }} /> : null;
}